import { Injectable, EventEmitter } from '@angular/core';
import { Observable ,  Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class MessageService {
  private subjectLat = new Subject<any>();
  public googleLogin = new Subject<any>();
  public WALogin = new Subject<any>();
  public oktaLogin = new Subject<any>();
  private subjectInfo = new Subject<any>();
  private subjectProfile = new Subject<any>();
  private subjectLogged = new Subject<any>();
  private subjectForm = new Subject<any>();
  private alertPush = new Subject<any>();
  private sendBussinessToMap = new Subject<any>();
  public sendBussinessToBanner = new Subject<any>();
  private mapView = new Subject<any>();
  private mapLatLng = new Subject<any>();
  private sendDataRadius = new Subject<any>();
  merchantsLoaded = new Subject<boolean>();
  businessCategoryPageHidden = new Subject<boolean>();
  merchantList= new Subject<boolean>();
  templateListData = new Subject<number>();
  templateFormData = new Subject<boolean>();
  public emitCvvForFAC = new Subject<any>();
  public openD2cOverlay = new Subject<any>();
  public emitNumberForPaytm = new Subject<any>();

  openLoginModal: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  onLocationChange: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public BannerList: BehaviorSubject<any> = new BehaviorSubject<any> (null);
  noProductCustomOrder: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  hideCardList: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  sendCardInfoToPaymentLaundry: BehaviorSubject<any> = new BehaviorSubject<any>(false);

  public merchantFilterEnabled: boolean = false;
  public showLoginPopup: boolean = false; 
  public redirection : boolean = true;

  addNotificationData: EventEmitter<any> = new EventEmitter<any>();
  showOrderData: EventEmitter<any> = new EventEmitter<any>();
  setCityInParent: EventEmitter<any> = new EventEmitter<any>();
  openSignUp: EventEmitter<any> = new EventEmitter<any>();
  openOtp: EventEmitter<any> = new EventEmitter<any>();
  profilePhoneUpdate: EventEmitter<any> = new EventEmitter<any>();
  storageRemovedUpdate: EventEmitter<any> = new EventEmitter<any>();
  clearCartData: EventEmitter<any> = new EventEmitter<any>();
  sendIndex: EventEmitter<any> = new EventEmitter<any>();
  userLoggedIn: EventEmitter<any> = new EventEmitter<any>();
  openDiffrentAccount: EventEmitter<any> = new EventEmitter<any>();
  userLoggedOut: EventEmitter<any> = new EventEmitter<any>();
  sendDelivery: EventEmitter<any> = new EventEmitter<any>();
  sendBusinessCategoryId: EventEmitter<any> = new EventEmitter<any>();
  sendCategoryNameLabel: EventEmitter<any> = new EventEmitter<any>();
  getCategoryFiltersEvent: EventEmitter<any> = new EventEmitter<any>();
  applyFilterEvent: EventEmitter<any> = new EventEmitter<any>();
  showFilterIcon: EventEmitter<any> = new EventEmitter<any>();
  sendRentalFilter: EventEmitter<any> = new EventEmitter<any>();
  sendLocationOfLoginSignup: EventEmitter<any> = new EventEmitter<any>();
  sendLocationOfLoginToSignupHybrid: EventEmitter<any> = new EventEmitter<any>();
  sendStripeOneStepPaymentData: EventEmitter<any> = new EventEmitter<any>();
  sendHeaderDataValue:EventEmitter<any> = new EventEmitter<any>();
  onOtpModalClose:  EventEmitter<any> = new EventEmitter<any>();
  goToCartCheckedValue:  EventEmitter<any> = new EventEmitter<any>();
  goToCartCheckedCheckoutValue: EventEmitter<any> = new EventEmitter<any>();
  sendCategoriesDataValue: EventEmitter<any> = new EventEmitter<any>();
  closeHeaderCartValue:EventEmitter<any> = new EventEmitter<any>();
  showCartValueInHeader:EventEmitter<any> = new EventEmitter<any>();
  updateCartLengthInHeader: EventEmitter<any> = new EventEmitter<any>();
  sendDataForCategoryValue: EventEmitter<any> = new EventEmitter<any>();
  sendFilterDataValue: EventEmitter<any> = new EventEmitter<any>();
  openAgePopupValue:EventEmitter<any> = new EventEmitter<any>();
  showDeliveryMessageValue:EventEmitter<any> = new EventEmitter<any>();
  clearBannerSectionValue:EventEmitter<any> = new EventEmitter<any>();
  loginSuccessValue:EventEmitter<any> = new EventEmitter<any>();
  scrollFilterPagination:EventEmitter<any> = new EventEmitter<any>();
  showShimmerDatavalue: EventEmitter<any> = new EventEmitter<any>();
  productListValue: EventEmitter<any> = new EventEmitter<any>();
  openLoginModalBySignupValue: EventEmitter<any> = new EventEmitter<any>();
  openLoginModalHybridBySignupValue: EventEmitter<any> = new EventEmitter<any>();
  openForgotPassword : EventEmitter<any> = new EventEmitter<any>();
  openForgotPasswordHybrid : EventEmitter<any> = new EventEmitter<any>();
  otpModalFalseValue: EventEmitter<any> = new EventEmitter<any>();
  openLoginModalHybridByChangePsw: EventEmitter<any> = new EventEmitter<any>();
  openDifferentAccountAccessToken: EventEmitter<any> = new EventEmitter<any>();
  clearPromo: EventEmitter<any> = new EventEmitter<any>();
  getMapView = this.mapView.asObservable();
  getLatlng = this.mapLatLng.asObservable();
  getChangedRadius = this.sendDataRadius.asObservable();
  getBussinessData = this.sendBussinessToMap.asObservable();

  sendMessage(lat: string, lng: string, city: string, search_text: string) {
    this.subjectLat.next({ lat: lat, lng: lng, city: city, text: search_text });
  }
  getMessage(): Observable<any> {
    return this.subjectLat.asObservable();
  }

  loginWithDiffrentAccountEmitter() {
    this.openDiffrentAccount.emit();
  }
  loginWithDifferentAccountAccessTokenEmitter(){
    this.openDifferentAccountAccessToken.emit();
  }
  emitOpenLoginModalBheavior(value : boolean){  
    this.showLoginPopup = value;  
    this.openLoginModal.next(this.showLoginPopup);
  }
  setRestaurantInfo(data: object) {
    this.subjectInfo.next(data);
  }

  getRestaurantData(): Observable<any> {
    return this.subjectInfo.asObservable();
  }

  sendProfileName(name: string) {
    this.subjectProfile.next({ name: name });
  }

  getProfileName(): Observable<any> {
    return this.subjectProfile.asObservable();
  }

  sendLoggedIn(bool: boolean) {
    this.subjectLogged.next({ logged: bool });
    this.userLoggedIn.emit();
  }

  getLoggedStatus(): Observable<any> {
    return this.subjectLogged.asObservable();
  }

  sendClearForm() {
    this.subjectForm.next(null);
  }

  getClearForm(): Observable<any> {
    return this.subjectForm.asObservable();
  }

  addNotification(data) {
    this.addNotificationData.emit(data);
  }
  showOrderDetail(data) {
    this.showOrderData.emit(data);
  }
  setCityInRestaurant(data) {
    this.setCityInParent.emit(data);
  }
  openSignUpPage(data) {
    this.openSignUp.emit(data);
  }
  openOtpPage(data){
    this.openOtp.emit(data);
  }
  profilePhone(data) {
    this.profilePhoneUpdate.emit(data);
  }
  storageRemoved(data) {
    this.storageRemovedUpdate.emit(data);
  }

  clearCartOnly() {
    this.clearCartData.emit();
  }

  sendProductIndexToDetails(data) {
    this.sendIndex.emit(data);
  }

  logoutUser() {
    this.userLoggedOut.emit();
  }
  sendAlert(obj: Object) {
    this.alertPush.next(obj);
  }

  getAlert() {
    return this.alertPush.asObservable();
  }
  sendDeliveryMode(data) {
    this.sendDelivery.emit(data);
  }

  sendBusinessCategory(data) {
    this.sendBusinessCategoryId.emit(data);
  }

  sendCategoryName(categoryName: string) {
    this.sendCategoryNameLabel.emit(categoryName);
  }

  applyFilters(data) {
    this.applyFilterEvent.emit(data);
  }

  rentalFilter(data) {
    this.sendRentalFilter.emit(data);
  }

  getLoginSignupLocation(data) {
    this.sendLocationOfLoginSignup.emit(data);
  }
  getLoginToSignupLocationHybrid(data){
    this.sendLocationOfLoginToSignupHybrid.emit(data);
  }

  emitStripeOneStepPaymentData(data){
    this.sendStripeOneStepPaymentData.emit(data);
  }


  sendDataToMap(data) {
    this.sendBussinessToMap.next(data);
  }
  sendDataToBanner(data) {
    this.sendBussinessToBanner.next(data);
  }
  mapListCheck(data) {
    this.mapView.next(data);
  }
  sendRadius(data) {
    this.sendDataRadius.next(data);
  }
  sendLatlng(data1, data2 ) {
   let val = {
      lat: data1,
      lng: data2
    };
    this.mapLatLng.next(val);
  }

  openD2cOvarlayOnStorePage(){
    this.openD2cOverlay.next(true);
  }
  sendHeaderData(data){
    this.sendHeaderDataValue.next(data);
  }
  goToCartChecked(data){
    this.goToCartCheckedValue.emit(data)
  }
  goToCartCheckedCheckout(data){
    this.goToCartCheckedCheckoutValue.emit(data)
  }
  sendCategoriesData(data){
    this.sendCategoriesDataValue.emit(data)
  }
  closeHeaderCart(data){
    this.closeHeaderCartValue.emit(data)
  }
  showCartValue(data){
    this.showCartValueInHeader.emit(data)
  }
  updateCartLength(data){
    this.updateCartLengthInHeader.emit(data)
  }
  sendDataForCategory(data){
    this.sendDataForCategoryValue.emit(data);
  }
  sendFilterData(data){
    this.sendFilterDataValue.emit(data);
  }
  openAgePopup(data){
    this.openAgePopupValue.emit(data);
  }
  showDeliveryMessage(data){
    this.showDeliveryMessageValue.emit(data);
  }
  clearBannerSection(data){
    this.clearBannerSectionValue.emit(data);
  }
  loginSuccess(data){
    this.loginSuccessValue.emit(data);
  }
  scrollFilterPaginationMsg(data){
    this.scrollFilterPagination.emit(data);
  }
  showShimmerData(data){
    this.showShimmerDatavalue.emit(data);
  }
  productList(data){
    this.productListValue.emit(data);
  }
  openLoginModalBySignup(data){
    this.openLoginModalBySignupValue.emit(data);
  }
  openLoginModalHybridBySignup(data){
    this.openLoginModalHybridBySignupValue.emit(data);
  }
  openForgotPasswordModal(data){
    this.openForgotPassword.emit(data);
  }
  openForgotPasswordModalHybrid(data){
    this.openForgotPasswordHybrid.emit(data);
  }
  otpModalFalse(data){
    this.otpModalFalseValue.emit(data);
  }
  openLoginHybridByChangePsw(data){
    this.openLoginModalHybridByChangePsw.emit(data);
  }
}

